<template>
  <div>
    <b-form-group v-bind:label="Datafield.label" v-bind:description="Datafield.label">
    <b-input-group>
      <b-input-group-prepend>
        <b-input-group-text><i class="fa fa-chevron-right"></i></b-input-group-text>
      </b-input-group-prepend>
      <b-form-file @change="processFile($event)" :required="Datafield.required" v-model="measurementValueDisplay" accept=".jpg, .png" :name="Datafield.name" :state="Boolean(file)" placeholder="Choose a file..."></b-form-file>
    </b-input-group>
    </b-form-group>
  </div>
</template>
<script>
export default {
  name: 'inputFile',
  props: {
    field: { required: true },
    data: { required: true }
  },
  data: function () {
    return {
      Datafield: {},
      Datadata: '',
      enteredValue: '',
      file: {},
      formData: new FormData()
    }
  },
  mounted () {
    this.Datafield = this.field
    this.Datadata = this.data
    this.enteredValue = this.data
  },
  computed: {
    measurementValueDisplay: {
      get: function () {
        return this.enteredValue
      },
      set: function (newValue) {
        this.enteredValue = newValue
      }
    }
  },
  methods: {
    processFile (event) {
      this.file = event.target.files[0]
      this.formData.append('myFile', this.file, this.file.name)
    },
    sendFile () {
      this.$store.dispatch('adminUsersCreateIMG',this.formData).then(response => {
        alert('sended')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/form/inputFile.vue